import { Ul } from './style';

const Loading = () => (
  <Ul>
    <li className="li li-1" />
    <li className="li li-2" />
    <li className="li li-3" />
    <li className="li li-4" />
    <li className="li li-5" />
    <li className="li li-6" />
  </Ul>
);

export default Loading;
